const css = `.specific-school .ant-select-item-option-content {
  padding-left: 20px !important;
}
.specific-school .rc-virtual-list-holder-inner div:not(:last-child) .ant-select-item-option-content {
  border-bottom: 1px solid lightgray;
}
.specific-school .ant-select-item-option-state {
  background: #2c2ca4;
  border: 1px solid #2c2ca4;
  color: white !important;
  height: 1rem;
  left: 12px !important;
  margin-top: 3px;
  position: absolute !important;
  text-align: center;
  width: 1rem;
}
.specific-school .ant-select-item-option-selected,
.specific-school .ant-select-item-option-active {
  background: none !important;
}
.specific-school .ant-select-item {
  padding-bottom: 0 !important;
}
.specific-school .ant-select-item-option-state > .anticon {
  vertical-align: 0.5em;
}
.specific-school .ant-select-item-option:not(.ant-select-item-option-selected) .ant-select-item-option-content::before {
  border: 2px solid #2c2ca4;
  color: white;
  content: ".";
  display: inline-block;
  height: 1rem;
  left: 12px;
  margin-right: 3px;
  padding-left: 0.7rem;
  position: absolute !important;
  top: 0.5rem;
  width: 1rem;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
